const css = `.specific-school .ant-select-item-option-content {
  padding-left: 20px !important;
}
.specific-school .rc-virtual-list-holder-inner div:not(:last-child) .ant-select-item-option-content {
  border-bottom: 1px solid lightgray;
}
.specific-school .ant-select-item-option-state {
  background: #2c2ca4;
  border: 1px solid #2c2ca4;
  color: white !important;
  height: 1rem;
  left: 12px !important;
  margin-top: 3px;
  position: absolute !important;
  text-align: center;
  width: 1rem;
}
.specific-school .ant-select-item-option-selected,
.specific-school .ant-select-item-option-active {
  background: none !important;
}
.specific-school .ant-select-item {
  padding-bottom: 0 !important;
}
.specific-school .ant-select-item-option-state > .anticon {
  vertical-align: 0.5em;
}
.specific-school .ant-select-item-option:not(.ant-select-item-option-selected) .ant-select-item-option-content::before {
  border: 2px solid #2c2ca4;
  color: white;
  content: ".";
  display: inline-block;
  height: 1rem;
  left: 12px;
  margin-right: 3px;
  padding-left: 0.7rem;
  position: absolute !important;
  top: 0.5rem;
  width: 1rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
